<template>
  <div>
    <form @submit.prevent="submit">
      <div class="container-main">
        <div>
          <h2 class="mb-5">Dados Gerais</h2>
          <v-row>
            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'contrato_guarda_chuva'"
                v-model="formulario.contrato_guarda_chuva" placeholder="Contrato Guarda Chuva"
                data-vv-as="Contrato Guarda Chuva" v-validate="'required|max:100'"
                :error="validationErrors.first('contrato_guarda_chuva')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent 
                type="text" class="input-background" :name="'custo_instalacao'"
                v-model="formulario.custo_instalacao" placeholder="Custo de Instalação" data-vv-as="Custo de Instalação"
                v-validate="'required'" :error="validationErrors.first('custo_instalacao')"
                v-currency="{currency: {}, allowNegative: false}"
              />
            </v-col>

            <v-col>
              <SGPFormInputComponent
                type="text" class="input-background" :name="'mensalidade'"
                v-model="formulario.mensalidade" placeholder="Mensalidade" data-vv-as="Mensalidade"
                v-validate="'required'" :error="validationErrors.first('mensalidade')"
                v-currency="{currency: {}, allowNegative: false}"  
              />
            </v-col>

            <v-col>
                <SGPFormSelectComponent 
                  :name="'ctrl_prazo_contratual_id'" class="input-background" :listaDeOptions="listaDePrazosContratuais"
                  v-model="formulario.ctrl_prazo_contratual_id" :optionLabel="'prazo'"  placeholder="Prazo Contratual do Serviço"
                  data-vv-as="Prazo Contratual do Serviço" v-validate="'required'" :error="validationErrors.first('regional')"
                />
            </v-col>
          </v-row>


          <v-row>
            <v-col>
              <SGPFormSelectComponent :name="'regional'" class="input-background" :listaDeOptions="listaDeRegionais"
                v-model="formulario.ctrl_regional_id" :optionLabel="'regional'" placeholder="Regional"
                data-vv-as="Regional" v-validate="'required'" :error="validationErrors.first('regional')" />
            </v-col>

            <v-col>
                <SGPFormInputComponent type="date" class="input-background" :name="'prazo_instalacao'"
                v-model="formulario.prazo_instalacao" placeholder="Prazo Instalação" data-vv-as="Prazo Instalação"
                v-validate="'required'" :error="validationErrors.first('prazo_instalacao')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="date" class="input-background" :name="'data_pedido'"
                v-model="formulario.data_pedido" placeholder="Data de Pedido" data-vv-as="Data de Pedido"
                v-validate="'required|after_or_equal_today'" :error="validationErrors.first('data_pedido')" />
            </v-col>

            <v-col>
              <SGPFormSelectComponent class="input-background" :name="'ctrl_tipo_solicitacao_id'"
                :listaDeOptions="listaTipoSolicitacao" v-model="formulario.ctrl_tipo_solicitacao_id"
                :optionLabel="'nome'" :optionValue="'id'" placeholder="Tipo de Solicitação"
                data-vv-as="Tipo de Solicitação" v-validate="'required'"
                :error="validationErrors.first('ctrl_tipo_solicitacao_id')" />
            </v-col>

            <v-col>
              <SGPFormSelectComponent class="input-background" :name="'ctrl_tipo_servico_id'"
                :listaDeOptions="listaDeTipoServico" v-model="formulario.ctrl_tipo_servico_id" :optionLabel="'nome'"
                :optionValue="'id'" placeholder="Tipo de Serviço" data-vv-as="Tipo de Serviço" v-validate="'required'"
                :error="validationErrors.first('ctrl_tipo_servico_id')" />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <SGPFormSelectComponent class="input-background" :name="'ctrl_provedor_id'"
                :listaDeOptions="listaDeProvedores" v-model="formulario.ctrl_provedor_id" :optionLabel="'nome'"
                :optionValue="'id'" placeholder="Provedor" data-vv-as="Provedor" v-validate="'required'"
                :error="validationErrors.first('ctrl_provedor_id')" />
            </v-col>
            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'cidade_provedor'"
                v-model="formulario.cidade_provedor" placeholder="Cidade Provedor" data-vv-as="Cidade Provedor"
                v-validate="'required|max:255'" :error="validationErrors.first('cidade_provedor')" />
            </v-col>
            <v-col>
              <SGPFormSelectComponent 
                class="input-background" :name="'ctrl_estado_provedor_id'" :listaDeOptions="listaDeCtrlEstados"
                v-model="formulario.ctrl_estado_provedor_id" :optionLabel="'uf'" placeholder="UF Provedor"
                data-vv-as="UF Provedor" v-validate="'required'" :error="validationErrors.first('ctrl_estado_provedor_id')"
              />
            </v-col>
            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'velocidade'"
                v-model="formulario.velocidade" placeholder="Velocidade" data-vv-as="Velocidade"
                v-validate="'required|max:50'" :error="validationErrors.first('velocidade')" />
            </v-col>

            <v-col>
              <SGPFormSelectComponent class="input-background" :name="'tipo_ip'" :listaDeOptions="listaDeTiposIp"
                v-model="formulario.tipo_ip" :optionLabel="'label'" :optionValue="'value'" placeholder="Tipo de IP"
                data-vv-as="Tipo de IP" v-validate="'required'" :error="validationErrors.first('tipo_ip')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'cnl'" v-model="formulario.cnl"
                placeholder="CNL" data-vv-as="CNL" v-validate="'required|max:100'"
                :error="validationErrors.first('cnl')" />
            </v-col>
            <v-col>
              <SGPFormInputComponent type="number" class="input-background" :name="'sgp_id'" v-model="formulario.sgp_id"
                placeholder="SGP ID" data-vv-as="SGP ID" v-validate="'required|integer'"
                :error="validationErrors.first('sgp_id')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="number" class="input-background" :name="'cod_circuito'"
                v-model="formulario.cod_circuito" placeholder="Código do Circuito" data-vv-as="Código do Circuito"
                v-validate="'required|integer'" :error="validationErrors.first('cod_circuito')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'ponta'" v-model="formulario.ponta"
                placeholder="Ponta" data-vv-as="Ponta" v-validate="'required|max:100'"
                :error="validationErrors.first('ponta')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'pedido_cla'"
                v-model="formulario.pedido_cla" placeholder="Pedido CLA" data-vv-as="Pedido CLA"
                v-validate="'required|max:100'" :error="validationErrors.first('pedido_cla')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent
                type="text"
                name="designacao_claro"
                v-model="formulario.designacao_claro"
                :items="designacoes"
                item-text="designacao"
                item-value="id"
                :search-input="termoDesignacao"
                @update:search-input="buscarDesignacoes"
                placeholder="Designação"
                data-vv-as="Designação"
                v-validate="'required'"
                :error="validationErrors.first('designacao_claro')"
                :loading="carregandoDesignacoes"
                clearable
              />
            </v-col>
          </v-row>
        </div>

        <div class="mt-5">
          <h2 class="mb-5">Dados da Contratante (Claro)</h2>
          <v-row>
            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'responsavel_contato'"
                v-model="formulario.responsavel_contato" placeholder="Responsável Contato"
                data-vv-as="Responsável Contato" v-validate="'required|max:255'"
                :error="validationErrors.first('responsavel_contato')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent 
                type="text" class="input-background" :name="'responsavel_fone'"
                v-model="formulario.responsavel_fone" placeholder="Telefone do Responsável"
                data-vv-as="Telefone do Responsável" v-validate="'required|max:20'"
                :error="validationErrors.first('responsavel_fone')" 
                v-mask="['(##) ####-#### ', '(##) # ####-####']"
              />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="email" class="input-background" :name="'responsavel_email'"
                v-model="formulario.responsavel_email" placeholder="Email do Responsável"
                data-vv-as="Email do Responsável" v-validate="'required|email|max:255'"
                :error="validationErrors.first('responsavel_email')" />
            </v-col>
          </v-row>
        </div>

        <div class="mt-5">
          <h2 class="mb-5">Dados do Cliente Final</h2>
          <v-row>
            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'nome_fantasia'"
                v-model="formulario.nome_fantasia" placeholder="Nome Fantasia" data-vv-as="Nome Fantasia"
                v-validate="'required|max:255'" :error="validationErrors.first('nome_fantasia')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="text" class="input-background" :name="'endereco'"
                v-model="formulario.endereco" placeholder="Endereço" data-vv-as="Endereço"
                v-validate="'required|max:255'" :error="validationErrors.first('endereco')" />
            </v-col>

            <v-col>
              <SGPFormInputComponent type="number" class="input-background" :name="'id_site_cliente'"
                v-model="formulario.id_site_cliente" placeholder="ID Site Cliente" data-vv-as="ID Site Cliente"
                v-validate="'required|integer'" :error="validationErrors.first('id_site_cliente')" />
            </v-col>
          </v-row>
        </div>

        <v-row class="mt-5">
          <v-col>
            <div class="container-botoes">
              <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
                type="submit">
                {{ tipoFormulario === 'salvar' ? 'Abrir Ticket' : 'Atualizar Ticket' }}
              </button>

              <button
                class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
                type="button" @click="fecharModal">
                Cancelar
              </button>
            </div>
          </v-col>
        </v-row>
      </div>
    </form>
    <SGPModalComponent
      titulo="Novo Ticket Instalação"
      v-if="abrirModalPcoWorkflowId && !loadingPcoWorkflows"
      tamanho="sm"
      @sgpModalFechar="fecharModalNovoTicket()"
    >
      <h5 style="text-align: center;">ModosWeb ID <b>{{ novoPcoWorkflowId }}</b> gerado com sucesso!</h5>
    </SGPModalComponent>
    <SGPLoadingComponent v-if="loadingPcoWorkflows"/>
  </div>
</template>

<style scoped>
.container-main {
  background-color: rgb(229, 231, 235);
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
  padding: 20px;
  border-radius: 10px;
}

.input-background {
  background-color: #f0f0f0;
}

.designacao-autocomplete ::v-deep .v-input__slot {
  min-height: 44px !important;
}

.designacao-autocomplete ::v-deep .v-input__control {
  min-height: 44px;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex';
import { converterMoedaParaDecimal } from '@/common/boot/Utils'

export default {
  name: "FormularioTicketInstalacaoComponent",
  props: {
    tipoFormulario: {
      type: String,
      default: 'salvar'
    },
    ticket: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      formulario: this.ticket ? { ...this.ticket } : {
        ctrl_workflow_id: '',
        ctrl_provedor_id: '',
        cidade_provedor: '',
        ctrl_estado_provedor_id: '',
        ctrl_tipo_solicitacao_id: '',
        ctrl_tipo_servico_id: '',
        contrato_guarda_chuva: '',
        custo_instalacao: '',
        mensalidade: '',
        ctrl_prazo_contratual_id: '',
        ctrl_regional_id: '',
        prazo_instalacao: '',
        data_pedido: '',
        velocidade: '',
        tipo_ip: '',
        cnl: '',
        sgp_id: '',
        cod_circuito: '',
        ponta: '',
        pedido_cla: '',
        nome_fantasia: '',
        endereco: '',
        id_site_cliente: '',
        responsavel_contato: '',
        responsavel_fone: '',
        responsavel_email: '',
        identificacao_acesso_provedor: '',
        designacao_claro: ''
      },
      carregandoDesignacoes: false,
      designacoes: [],
      termoDesignacao: '',
      timeoutBusca: null,
      listaDeRegioes: [
        { label: 'Bahia e Sergipe', value: 'Bahia e Sergipe' },
        { label: 'Centro Oeste', value: 'Centro Oeste' },
        { label: 'Minas Gerais', value: 'Minas Gerais' },
        { label: 'Nordeste', value: 'Nordeste' },
        { label: 'Norte', value: 'Norte' },
        { label: 'Paraná', value: 'Paraná' },
        { label: 'Rio de Janeiro e Espírito Santo', value: 'Rio de Janeiro e Espírito Santo' },
        { label: 'Rio Grande do Sul', value: 'Rio Grande do Sul' },
        { label: 'Santa Catarina', value: 'Santa Catarina' },
        { label: 'São Paulo Centro', value: 'São Paulo Centro' },
        { label: 'São Paulo Metro', value: 'São Paulo Metro' },
        { label: 'São Paulo Oeste', value: 'São Paulo Oeste' },
        { label: 'São Paulo Leste', value: 'São Paulo Leste' },
        { label: 'São Paulo Interior', value: 'São Paulo Interior' }
      ],
      listaDeTiposIp: [
        { label: 'Público', value: 'publico' },
        { label: 'Privado', value: 'privado' }
      ],
      abrirModalPcoWorkflowId: false,
      novoPcoWorkflowId: '',
    }
  },
  created() {
    this.listarProvedores();
    this.listarWorkflows();
    this.listarTiposSolicitacao();
    this.listarTiposServico();
    this.listarCtrlEstados();
    this.listarPrazosContratuais();
    this.listarRegionaisPermitidas();
  },
  computed: {
    ...mapGetters('ctrlWorkflow', ['listaDeWorkflows']),
    ...mapGetters('ctrlProvedores', ['listaDeProvedores']),
    ...mapGetters('ctrlDesignacao', ['listaDeDesignacao', 'loadingDesignacao']),
    ...mapGetters('ctrlTipoSolicitacao', ['listaDeTiposSolicitacao']),
    ...mapGetters('ctrlTipoServico', ['listaDeTiposServico']),
    ...mapGetters('ctrlEstadosWf', ['listaDeCtrlEstados']),
    ...mapGetters('tickets', ['loadingPcoWorkflows']),
    ...mapGetters('ctrlPrazosContratuais', ['listaDePrazosContratuais']),
    ...mapGetters('ctrlRegionais', ['listaDeRegionais']),

    listaTipoSolicitacao() {
      return this.listaDeTiposSolicitacao || [];
    },

    listaDeTipoServico() {
      return this.listaDeTiposServico || [];
    },

    searchData: {
      get() {
        return this.searchInput;
      },
      set(value) {
        this.$emit('update:search-input', value);
      }
    },
  },
  methods: {
    ...mapActions('tickets', ['abrirTicketInstalacao', 'atualizarTicketInstalacao']),
    ...mapActions('ctrlWorkflow', ['listarWorkflows']),
    ...mapActions('ctrlProvedores', ['listarProvedores']),
    ...mapActions('ctrlDesignacao', ['listarDesignacao']),
    ...mapActions('ctrlTipoSolicitacao', ['listarTiposSolicitacao']),
    ...mapActions('ctrlTipoServico', ['listarTiposServico']),
    ...mapActions('ctrlEstadosWf', ['listarCtrlEstados']),
    ...mapActions('ctrlPrazosContratuais', ['listarPrazosContratuais']),
    ...mapActions('ctrlRegionais', ['listarRegionaisPermitidas']),
    
    async buscarDesignacoes(termo) {
      clearTimeout(this.timeoutBusca);

      const busca = (termo || '').trim();

      if (busca.length < 5) {
        this.designacoes = [];
        return;
      }

      this.timeoutBusca = setTimeout(async () => {
        this.carregandoDesignacoes = true;
        try {
          const response = await this.listarDesignacao({
            page: 1,
            current_page: 1,
            per_page: 50,
            designacao: busca,
          });

          this.designacoes = response?.data?.data?.data || [];

        } catch (error) {
          console.error('Erro ao buscar designações:', error);
          this.designacoes = [];
        } finally {
          this.carregandoDesignacoes = false;
        }
      }, 300);
    },


    limparCampos() {
      Object.keys(this.formulario).forEach(k => (this.formulario[k] = ''));
      this.$validator.reset();
    },

    async submit() {
      const valido = await this.$validator.validateAll();
      if (!valido) return;

      let payload = { ...this.formulario };
      payload.custo_instalacao = converterMoedaParaDecimal(payload.custo_instalacao);
      payload.mensalidade = converterMoedaParaDecimal(payload.mensalidade);      

      const resp = await this.abrirTicketInstalacao(payload);
      if (!resp) return;

      if (resp.pco_workflow?.tarefas?.length > 0) {

        const primeiraTarefa = resp.pco_workflow.tarefas[0];

        this.$router.push({
          name: 'ficha-tecnica-tarefa',
          params: { pco_tarefa_id: primeiraTarefa.id }
        });
      }

      this.novoPcoWorkflowId = resp?.pco_workflow_id;
      this.abrirModalPcoWorkflowId = true;
      this.limparCampos();
      // this.fecharModal();
    },

    fecharModalNovoTicket () {
      this.abrirModalPcoWorkflowId = false;
      this.novoPcoWorkflowId = '';
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal();
    },

    converterMoedaParaDecimal
  },
  watch: {
    termoDesignacao(termo) {
      this.buscarDesignacoes(termo);
    },
  },
};
</script>
